import React from 'react';
import FloodRiskToolV4 from './components/FloodRiskToolV4';

function App() {
  return (
    <div>
      <FloodRiskToolV4 />
    </div>
  );
}

export default App;
